import React from 'react';
import * as styles from './PageBlocks.module.styl';

export default function PaymentTrustBar() {
  return (
    <div className={styles.verifiedBlock}>
      <img
        alt=""
        style={{ height: 50 }}
        className="lozad"
        data-src="https://img.paperform.co/fetch/w_1/https://s3-ap-southeast-2.amazonaws.com/paperform/u-1/0/2019-05-01/jr136m5/L_Color_Solid.svg"
      />
      <img
        alt=""
        style={{ height: 50 }}
        className="lozad"
        data-src="https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-light.png"
      />
      <img
        alt=""
        style={{ height: 50 }}
        className="lozad"
        data-src="https://img.paperform.co/fetch/w_600,f_auto/https://connect.squareup.com/connect-web/assets/built-with-square/brand_white-edcf1cc8a10da45f6d0e67215261bcd24f83a48336be84307d3ca62314963adf.png"
      />
      <img
        alt=""
        style={{ height: 50 }}
        className="lozad"
        data-src="https://img.paperform.co/fetch/w_600,f_auto/https://www.paypalobjects.com/webstatic/mktg/logo-center/PP_Acceptance_Marks_for_LogoCenter_266x142.png"
      />
    </div>
  );
}
